/* Cocon du Soir — thème Atelier du soir */
(function () {
  'use strict';
  var C = window.cocon || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function formatPrix(cents) {
    var f = (C.money || '{{amount_with_comma_separator}} €');
    var v = (cents / 100).toFixed(2);
    var virgule = v.replace('.', ',');
    var milliers = virgule.replace(/\B(?=(\d{3})+(?!\d))/g, '\u202f');
    return f.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, milliers)
            .replace(/\{\{\s*amount\s*\}\}/, v)
            .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
            .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(cents / 100))
            .replace(/<[^>]+>/g, '');
  }

  /* ---------- Lumière du soir ---------- */
  var HEURES = ['18', '19', '20', '21', '22', '23'];
  function poserHeure(h, memoriser) {
    h = String(h);
    if (HEURES.indexOf(h) < 0) h = '18';
    document.documentElement.dataset.heure = h;
    $$('[data-heure-valeur]').forEach(function (el) { el.textContent = h + 'h'; });
    $$('[data-curseur-heure]').forEach(function (el) { if (el.value !== h) el.value = h; });
    $$('[data-heure-phrase]').forEach(function (el) {
      var p = el.dataset['phrase' + h];
      if (p) el.textContent = p;
    });
    $$('.interrupteur').forEach(function (b) { b.setAttribute('aria-pressed', Number(h) >= 21 ? 'true' : 'false'); });
    if (memoriser) { try { localStorage.setItem('cocon-heure', h); } catch (e) {} }
  }
  document.addEventListener('input', function (e) {
    if (e.target.matches('[data-curseur-heure]')) poserHeure(e.target.value, true);
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.interrupteur');
    if (!b) return;
    var h = Number(document.documentElement.dataset.heure || 18);
    poserHeure(h >= 21 ? 18 : 22, true);
  });
  poserHeure(document.documentElement.dataset.heure || '18', false);

  /* ---------- Menu ---------- */
  var nav = $('.nav');
  var btnMenu = $('.menu-mobile-btn');
  if (btnMenu && nav) {
    btnMenu.addEventListener('click', function () {
      var ouvert = nav.classList.toggle('est-ouvert');
      btnMenu.setAttribute('aria-expanded', ouvert);
      document.body.style.overflow = ouvert ? 'hidden' : '';
      var ent = nav.closest('.entete');
      if (ouvert && ent) {
        var r = ent.getBoundingClientRect();
        nav.style.top = ent.offsetHeight + 'px'; nav.style.bottom = 'auto';
        nav.style.height = Math.max(200, window.innerHeight - r.bottom) + 'px';
      } else { nav.style.top = nav.style.bottom = nav.style.height = ''; }
    });
  }
  $$('.nav__item > button.nav__lien').forEach(function (b) {
    b.addEventListener('click', function () {
      var item = b.parentElement;
      var ouvert = !item.classList.contains('est-ouvert');
      $$('.nav__item.est-ouvert').forEach(function (i) { i.classList.remove('est-ouvert'); i.firstElementChild.setAttribute('aria-expanded', 'false'); });
      if (ouvert) { item.classList.add('est-ouvert'); b.setAttribute('aria-expanded', 'true'); }
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    $$('.nav__item.est-ouvert').forEach(function (i) { i.classList.remove('est-ouvert'); });
    fermerTiroir();
  });

  /* ---------- Recherche prédictive ---------- */
  var btnRech = $('[data-ouvrir-recherche]');
  var zoneRech = $('.recherche');
  if (btnRech && zoneRech) {
    btnRech.addEventListener('click', function () {
      zoneRech.classList.toggle('est-ouverte');
      var champ = $('input', zoneRech);
      if (zoneRech.classList.contains('est-ouverte') && champ) champ.focus();
    });
    var champ = $('input[name=q]', zoneRech), res = $('.recherche__resultats', zoneRech), minuteur;
    if (champ && res) champ.addEventListener('input', function () {
      clearTimeout(minuteur);
      var q = champ.value.trim();
      if (q.length < 2) { res.innerHTML = ''; return; }
      minuteur = setTimeout(function () {
        fetch(C.routes.search + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=6')
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var r = d.resources && d.resources.results || {};
            var html = '';
            (r.collections || []).slice(0, 2).forEach(function (c) { html += '<a href="' + c.url + '"><span>Collection · ' + c.title + '</span></a>'; });
            (r.products || []).forEach(function (p) {
              html += '<a href="' + p.url + '">' + (p.image ? '<img src="' + p.image + '&width=120" alt="" loading="lazy">' : '') + '<span>' + p.title + '<br><strong>' + p.price + ' €</strong></span></a>';
            });
            res.innerHTML = html || '<p class="petit">Aucun résultat pour « ' + q.replace(/</g, '') + ' ». Essayez « canapé », « nappe » ou « buffet ».</p>';
          }).catch(function () {});
      }, 220);
    });
  }

  /* ---------- Panier tiroir ---------- */
  var tiroir = $('#tiroir-panier');
  function ouvrirTiroir() { if (!tiroir) return; tiroir.classList.add('est-ouvert'); tiroir.setAttribute('aria-hidden', 'false'); var f = $('.tiroir__fermer', tiroir); if (f) f.focus(); document.body.style.overflow = 'hidden'; }
  function fermerTiroir() { if (!tiroir) return; tiroir.classList.remove('est-ouvert'); tiroir.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
  function rafraichirPanier(ouvrir) {
    return fetch('/?sections=panier-tiroir,compteur-panier')
      .then(function (r) { return r.json(); })
      .then(function (s) {
        var doc = new DOMParser().parseFromString(s['panier-tiroir'], 'text/html');
        var neuf = doc.querySelector('#tiroir-panier');
        if (neuf && tiroir) { tiroir.innerHTML = neuf.innerHTML; }
        var cpt = new DOMParser().parseFromString(s['compteur-panier'], 'text/html').querySelector('[data-compteur]');
        $$('[data-compteur]').forEach(function (el) { if (cpt) el.outerHTML = cpt.outerHTML; });
        if (ouvrir) ouvrirTiroir();
      });
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-ouvrir-panier]') && tiroir) { e.preventDefault(); ouvrirTiroir(); }
    if (e.target.closest('[data-fermer-panier]')) { e.preventDefault(); fermerTiroir(); }
    var suppr = e.target.closest('[data-supprimer-ligne]');
    if (suppr) { e.preventDefault(); changerLigne(suppr.dataset.supprimerLigne, 0); }
    var q = e.target.closest('[data-ligne-qte]');
    if (q) {
      e.preventDefault();
      var input = q.parentElement.querySelector('input');
      var n = Math.max(0, Number(input.value) + Number(q.dataset.delta));
      changerLigne(q.dataset.ligneQte, n);
    }
  });
  function changerLigne(cle, qte) {
    fetch(C.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: cle, quantity: qte }) })
      .then(function () { if (document.body.classList.contains('gabarit-cart')) location.reload(); else rafraichirPanier(false); });
  }

  /* ---------- Formulaires d'ajout ---------- */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.matches('form[data-ajout-panier]')) return;
    e.preventDefault();
    var orient = f.querySelector('[data-orientation]');
    if (orient && !orient.querySelector('input:checked')) {
      orient.classList.add('est-a-choisir');
      var m0 = f.querySelector('[data-message-panier]');
      if (m0) { m0.hidden = false; m0.textContent = "Choisissez l'orientation de l'angle (à gauche ou à droite)."; }
      orient.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    var btn = $('[type=submit]', f) || $('.barre-achat button');
    var texte = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Ajout en cours…'; }
    var msg = $('[data-message-panier]', f);
    fetch(C.routes.cartAdd + '.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(f) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) { if (msg) { msg.hidden = false; msg.textContent = res.j.description || 'Ce produit n\'a pas pu être ajouté. Vérifiez la quantité disponible.'; } return; }
        if (msg) msg.hidden = true;
        if (document.body.classList.contains('gabarit-cart')) { location.reload(); return; }
        return rafraichirPanier(true);
      })
      .catch(function () { f.submit(); })
      .finally(function () { if (btn) { btn.disabled = false; btn.innerHTML = texte; } });
  });

  /* ---------- Quantité ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qte]');
    if (!b) return;
    var input = b.parentElement.querySelector('input');
    input.value = Math.max(1, Number(input.value || 1) + Number(b.dataset.qte));
  });

  /* ---------- Fiche produit ---------- */
  var fiche = $('[data-fiche]');
  if (fiche) {
    var donnees = JSON.parse($('[data-produit-json]', fiche).textContent);
    var form = $('form[data-ajout-panier]', fiche);
    var idInput = $('input[name=id]', form);
    var principal = $('.galerie__principale img', fiche);
    var vignettes = $$('.galerie__vignettes button', fiche);
    var indexImg = 0;

    function montrer(i) {
      if (!vignettes.length) return;
      indexImg = (i + vignettes.length) % vignettes.length;
      var v = vignettes[indexImg];
      principal.src = v.dataset.grande; principal.srcset = ''; principal.alt = v.dataset.alt || '';
      principal.dataset.zoom = v.dataset.zoom || v.dataset.grande;
      vignettes.forEach(function (x) { x.setAttribute('aria-current', x === v ? 'true' : 'false'); });
      $$('.galerie__points i', fiche).forEach(function (p, k) { p.classList.toggle('actif', k === indexImg); });
      document.dispatchEvent(new CustomEvent('cocon:image', { detail: { index: indexImg } }));
    }
    vignettes.forEach(function (v, i) { v.addEventListener('click', function () { montrer(i); }); });
    $$('[data-galerie]', fiche).forEach(function (b) { b.addEventListener('click', function () { montrer(indexImg + Number(b.dataset.galerie)); }); });
    var cadre = $('.galerie__principale', fiche);
    if (cadre) {
      var dx = null;
      cadre.addEventListener('touchstart', function (e) { dx = e.touches[0].clientX; }, { passive: true });
      cadre.addEventListener('touchend', function (e) { if (dx === null) return; var d = e.changedTouches[0].clientX - dx; if (Math.abs(d) > 40) { montrer(indexImg + (d < 0 ? 1 : -1)); cadre.dataset.balaye = '1'; setTimeout(function () { cadre.dataset.balaye = ''; }, 350); } dx = null; });
    }

    function varianteCourante() {
      var choix = $$('.option input:checked', fiche).map(function (i) { return i.value; });
      return donnees.variants.find(function (v) { return v.options.every(function (o, k) { return o === choix[k]; }); });
    }
    function majVariante() {
      var v = varianteCourante();
      var btn = $('[data-bouton-ajout]', fiche);
      var barreBtn = $('.barre-achat button');
      if (!v) { if (btn) { btn.disabled = true; btn.textContent = 'Combinaison indisponible'; } return; }
      idInput.value = v.id;
      $$('[data-prix]').forEach(function (el) { el.textContent = formatPrix(v.price); });
      (function () { var o = $('[data-offre]', fiche); var pct = o ? Number(o.dataset.offre) : 0; var net = v.price - Math.round(v.price * pct / 100); var b4 = $('[data-paiement-4x]', fiche); if (b4) { b4.hidden = net < 3000 || net > 200000; var q = $('[data-prix-4x]', b4); if (q) q.textContent = formatPrix(Math.round(net / 4)); var q3 = $('[data-prix-3x]', b4); if (q3) q3.textContent = formatPrix(Math.round(net / 3)); } })();
      $$('[data-prix-offre]').forEach(function (el) { var o = el.closest('[data-offre]'); var pct = o ? Number(o.dataset.offre) : 0; el.textContent = formatPrix(v.price - Math.round(v.price * pct / 100)); });
      $$('[data-prix-barre]').forEach(function (el) { el.hidden = !(v.compare_at_price > v.price); el.textContent = v.compare_at_price ? formatPrix(v.compare_at_price) : ''; });
      var txt = v.available ? 'Ajouter au panier' : 'Épuisé';
      [btn, barreBtn].forEach(function (b) { if (b) { b.disabled = !v.available; b.textContent = txt; } });
      var stock = $('[data-stock]', fiche);
      if (stock) {
        stock.className = 'stock' + (v.available ? '' : ' stock--epuise');
        stock.textContent = v.available ? 'En stock, prêt à être expédié' : 'Momentanément épuisé';
      }
      $$('.option__valeurs label', fiche).forEach(function (l) {
        var input = document.getElementById(l.htmlFor);
        if (!input) return;
        var pos = Number(input.dataset.position);
        var choix = $$('.option input:checked', fiche).map(function (i) { return i.value; });
        var ok = donnees.variants.some(function (x) { return x.available && x.options[pos] === input.value && x.options.every(function (o, k) { return k === pos || o === choix[k]; }); });
        l.classList.toggle('indispo', !ok);
      });
      if (v.featured_media) {
        var i = vignettes.findIndex(function (b) { return b.dataset.mediaId == v.featured_media.id; });
        if (i > -1) montrer(i);
      }
      try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); } catch (e) {}
    }
    $$('.option input', fiche).forEach(function (i) { i.addEventListener('change', majVariante); });

    /* Livraison estimée */
    var liv = $('[data-livraison]', fiche);
    if (liv) {
      var min = Number(liv.dataset.min), max = Number(liv.dataset.max);
      var ajoute = function (n) { var d = new Date(), c = 0; while (c < n) { d.setDate(d.getDate() + 1); var j = d.getDay(); if (j && j !== 6) c++; } return d; };
      var o = { weekday: 'long', day: 'numeric', month: 'long' };
      var cible = $('[data-livraison-dates]', liv);
      if (cible) cible.textContent = 'entre le ' + ajoute(min).toLocaleDateString('fr-FR', o) + ' et le ' + ajoute(max).toLocaleDateString('fr-FR', o);
    }

    /* Barre d'achat collante */
    var barre = $('.barre-achat');
    var cibleBtn = $('[data-bouton-ajout]', fiche);
    if (barre && cibleBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (en) { barre.classList.toggle('est-visible', !en.isIntersecting && en.boundingClientRect.top < 0); });
      }).observe(cibleBtn);
      var bb = $('button', barre);
      if (bb) bb.addEventListener('click', function () { if (form.requestSubmit) form.requestSubmit(); else form.submit(); });
    }

    /* Ça rentre chez moi ? */
    var outil = $('[data-gabarit]', fiche);
    if (outil) (function () {
      var source = outil.dataset.dimensions || (($('[data-description]', fiche) || {}).textContent || '') + ' ' + (($('.infos__titre', fiche) || {}).textContent || '');
      var m = source.replace(/,/g, '.').match(/(\d{2,3}(?:\.\d+)?)\s*(?:cm)?\s*[x×*]\s*(\d{2,3}(?:\.\d+)?)/i);
      if (!m) { outil.hidden = true; return; }
      var L = Number(m[1]), P = Number(m[2]);
      $('.gabarit-outil h3', outil).insertAdjacentHTML('afterend', '<p class="petit" style="margin:0 0 6px">Ce meuble : ' + L + ' × ' + P + ' cm au sol.</p>');
      var champL = $('[name=largeur]', outil), champP = $('[name=profondeur]', outil);
      var piece = $('.gabarit-outil__piece', outil), meuble = $('.gabarit-outil__meuble', outil), verdict = $('.gabarit-outil__verdict', outil);
      var calc = function () {
        var l = Number(champL.value), p = Number(champP.value);
        if (!l || !p) { verdict.textContent = 'Indiquez la largeur et la profondeur de l\'emplacement, en centimètres.'; return; }
        var plan = outil.querySelector('.gabarit-outil__plan');
        var maxL = Math.max(l, L) * 1.1, maxP = Math.max(p, P) * 1.1;
        var ech = Math.min(plan.clientWidth / maxL, plan.clientHeight / maxP);
        piece.style.width = (l * ech) + 'px'; piece.style.height = (p * ech) + 'px';
        meuble.style.width = (L * ech) + 'px'; meuble.style.height = (P * ech) + 'px';
        var marge = Math.min(l - L, p - P);
        meuble.classList.toggle('trop-grand', marge < 0);
        verdict.textContent = marge < 0
          ? 'Trop juste : il manque ' + Math.ceil(Math.max(L - l, P - p)) + ' cm. Regardez une taille au-dessous dans la même collection.'
          : (marge < 10 ? 'Ça rentre, avec ' + Math.floor(marge) + ' cm de marge. Prévoyez l\'accès lors de la livraison.' : 'Ça rentre largement : ' + Math.floor(marge) + ' cm de marge au plus juste.');
      };
      champL.addEventListener('input', calc); champP.addEventListener('input', calc);
    })();
  }

  /* ---------- Quiz ---------- */
  $$('[data-quiz]').forEach(function (q) {
    var etapes = $$('.quiz__etape', q), reponses = {}, barres = $$('.quiz__progression i', q);
    function aller(n) {
      etapes.forEach(function (e, i) { e.classList.toggle('est-active', i === n); });
      barres.forEach(function (b, i) { b.classList.toggle('fait', i < n || n === etapes.length - 1); });
      var t = etapes[n] && $('.quiz__question, h3', etapes[n]); if (t) { t.setAttribute('tabindex', '-1'); t.focus({ preventScroll: true }); }
    }
    q.addEventListener('click', function (e) {
      var b = e.target.closest('[data-reponse]');
      if (b) {
        var e2 = b.closest('.quiz__etape');
        reponses[e2.dataset.cle] = b.dataset.reponse;
        var idx = etapes.indexOf(e2);
        if (idx + 1 === etapes.length - 1) afficherResultat();
        aller(idx + 1);
      }
      if (e.target.closest('.quiz__recommencer')) { reponses = {}; aller(0); }
    });
    function afficherResultat() {
      var piece = reponses.piece || 'salon';
      var style = reponses.style || 'doux';
      var budget = reponses.budget || 'moyen';
      var res = q.querySelector('[data-resultat]');
      var cartes = JSON.parse(q.querySelector('[data-quiz-json]').textContent);
      var r = cartes[piece] || cartes.salon;
      var phrasesStyle = { doux: 'tout en douceur, velours et tons naturels', franc: 'aux lignes nettes et contrastées', chaleureux: 'aux matières chaleureuses, bois et textures' };
      var tri = budget === 'plaisir' ? '?sort_by=price-descending' : (budget === 'malin' ? '?sort_by=price-ascending' : '');
      res.querySelector('h3').textContent = r.titre;
      var pieces = { 'salon': 'Un salon', 'salle-a-manger': 'Une salle à manger', 'chambre': 'Une chambre', 'entree': 'Une entrée' };
      res.querySelector('p').textContent = (pieces[piece] || 'Un intérieur') + ' ' + (phrasesStyle[style] || '') + ' : voici par où commencer.';
      var a = res.querySelector('a.bouton'); a.href = r.meubles + tri; a.textContent = r.cta;
      var l = res.querySelector('.quiz__liens'); l.innerHTML = '';
      r.linge.forEach(function (x) { var el = document.createElement('a'); el.href = x[1]; el.textContent = x[0]; l.appendChild(el); });
    }
  });

  /* ---------- FAQ ---------- */
  $$('[data-faq]').forEach(function (f) {
    var qs = $$('.question, .question2', f), filtres = $$('.faq__filtres button, .faq2__themes button', f), champ = $('.faq__recherche', f), vide = $('.faq__vide', f), theme = 'tout';
    function filtrer() {
      var t = (champ && champ.value || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
      var n = 0;
      qs.forEach(function (q) {
        var txt = q.textContent.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
        var ok = (theme === 'tout' || q.dataset.theme === theme) && (!t || txt.indexOf(t) > -1);
        q.hidden = !ok; if (ok) n++;
      });
      if (vide) vide.style.display = n ? 'none' : 'block';
    }
    filtres.forEach(function (b) { b.addEventListener('click', function () { theme = b.dataset.theme; filtres.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); }); filtrer(); }); });
    if (champ) champ.addEventListener('input', filtrer);
  });

  /* ---------- Filtres collection ---------- */
  var btnFiltres = $('[data-ouvrir-filtres]'), panneauFiltres = $('.filtres');
  if (btnFiltres && panneauFiltres) btnFiltres.addEventListener('click', function () { var o = panneauFiltres.classList.toggle('est-ouvert'); btnFiltres.setAttribute('aria-expanded', o); });
  $$('form[data-filtres]').forEach(function (f) {
    f.addEventListener('change', function (e) { if (e.target.matches('input[type=checkbox], select')) f.submit(); });
  });
  $$('select[data-tri]').forEach(function (s) {
    s.addEventListener('change', function () { var u = new URL(location.href); u.searchParams.set('sort_by', s.value); location.href = u; });
  });
})();

/* =====================================================================
   Salon d'exposition : intro, héros, vitrine, loupe, zoom, FAQ
   ===================================================================== */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var html = document.documentElement;
  var calme = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var sourisFine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ---------- Intro ---------- */
  var intro = $('[data-intro]');
  function reveler() { html.classList.add('est-revele'); }
  /* Vitesse : pas d'intro sur téléphone (la page s'affiche tout de suite) */
  var petitEcran = window.innerWidth < 750 || !(window.matchMedia && window.matchMedia('(hover: hover)').matches);
  if (!intro || html.classList.contains('sans-intro') || petitEcran) {
    requestAnimationFrame(function () { requestAnimationFrame(reveler); });
    if (intro) intro.remove();
  } else {
    var fini = false;
    var ouvrir = function () {
      if (fini) return; fini = true;
      intro.classList.add('ouvre');
      try { sessionStorage.setItem('cocon-intro', '1'); } catch (e) {}
      setTimeout(reveler, 260);
      setTimeout(function () { intro.remove(); }, 1350);
    };
    setTimeout(ouvrir, 1950);
    intro.addEventListener('click', ouvrir);
    document.addEventListener('keydown', function k() { ouvrir(); document.removeEventListener('keydown', k); });
  }

  /* ---------- Héros : couleur en direct + parallaxe ---------- */
  $$('[data-heros]').forEach(function (h) {
    var studio = $('[data-heros-studio]', h), meuble = $('[data-heros-meuble]', h);
    var img = meuble && $('img', meuble);
    var boutons = $$('.heros2__teintes .pastille', h);
    var lien = $('[data-heros-lien]', h), prix = $('[data-heros-prix]', h), nom = $('[data-heros-nom]', h);
    var courant = Math.max(0, boutons.findIndex(function (b) { return b.classList.contains('est-choisie'); }));
    var auto = null, touche = false;
    if (boutons[courant]) document.documentElement.style.setProperty('--ambiance', boutons[courant].dataset.teinte);
    function choisir(i, parUtilisateur) {
      var b = boutons[i]; if (!b || !img) return;
      courant = i;
      boutons.forEach(function (x) { var ok = x === b; x.classList.toggle('est-choisie', ok); x.setAttribute('aria-pressed', ok ? 'true' : 'false'); });
      studio.style.setProperty('--teinte', b.dataset.teinte);
      document.documentElement.style.setProperty('--ambiance', b.dataset.teinte);
      if (nom) nom.textContent = b.dataset.nom;
      var nouvelle = new Image();
      nouvelle.onload = function () {
        meuble.classList.add('change');
        setTimeout(function () {
          img.removeAttribute('srcset'); img.src = b.dataset.image;
          if (lien) { lien.href = b.dataset.url; lien.textContent = b.dataset.titre; }
          if (prix) prix.textContent = b.dataset.prix;
          requestAnimationFrame(function () { meuble.classList.remove('change'); });
        }, 360);
      };
      nouvelle.src = b.dataset.image;
      if (parUtilisateur) { touche = true; clearInterval(auto); }
    }
    /* Vitesse : sur téléphone, les photos des autres couleurs en 800 px au lieu de 1400 px */
    if (window.innerWidth < 750) boutons.forEach(function (b) { if (b.dataset.image) b.dataset.image = b.dataset.image.replace(/width=\d+/, 'width=800'); });
    boutons.forEach(function (b, i) { b.addEventListener('click', function () { choisir(i, true); }); });
    if (boutons.length > 1 && !calme) {
      /* Vitesse : les autres couleurs ne se chargent et ne défilent qu'après un premier geste du visiteur (toucher, défilement, souris) */
      var precharge = false, pret = false, vu = false, gestes = ['scroll', 'touchstart', 'pointermove', 'keydown'];
      var demarrer = function () {
        if (!pret || !vu) return;
        if (!precharge) { precharge = true; boutons.forEach(function (b) { var p = new Image(); p.src = b.dataset.image; }); }
        clearInterval(auto); if (!touche) auto = setInterval(function () { choisir((courant + 1) % boutons.length, false); }, 4200);
      };
      var go = function () { if (pret) return; pret = true; gestes.forEach(function (t) { window.removeEventListener(t, go); }); setTimeout(demarrer, 1500); };
      gestes.forEach(function (t) { window.addEventListener(t, go, { passive: true }); });
      if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { vu = true; setTimeout(demarrer, 2200); } else { vu = false; clearInterval(auto); } }); }, { threshold: .4 }).observe(h);
    }
    if (sourisFine && !calme && studio && meuble) {
      var arche = $('.heros2__arche', h), lampe = $('.heros2__lampe', h);
      studio.addEventListener('pointermove', function (e) {
        var r = studio.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
        meuble.style.transform = 'translate3d(' + (x * 26) + 'px,' + (y * 12) + 'px,0)';
        if (arche) arche.style.transform = 'translate3d(' + (x * -10) + 'px,' + (y * -6) + 'px,0)';
        if (lampe) lampe.style.transform = 'translate3d(' + (x * 40) + 'px,' + (y * 30) + 'px,0)';
      });
      studio.addEventListener('pointerleave', function () { meuble.style.transform = ''; if (arche) arche.style.transform = ''; if (lampe) lampe.style.transform = ''; });
    }
  });

  /* ---------- Vitrine défilante ---------- */
  $$('[data-vitrine]').forEach(function (v) {
    var rail = $('[data-vitrine-rail]', v), barre = $('[data-vitrine-barre]', v);
    var prec = $('[data-vitrine-pas="-1"]', v), suiv = $('[data-vitrine-pas="1"]', v);
    function maj() {
      var max = rail.scrollWidth - rail.clientWidth;
      var part = rail.clientWidth / rail.scrollWidth;
      if (barre) { barre.style.width = (part * 100) + '%'; barre.style.marginLeft = (max > 0 ? rail.scrollLeft / max * (100 - part * 100) : 0) + '%'; }
      if (prec) prec.disabled = rail.scrollLeft < 8;
      if (suiv) suiv.disabled = rail.scrollLeft > max - 8;
    }
    rail.addEventListener('scroll', maj, { passive: true }); window.addEventListener('resize', maj); maj();
    $$('[data-vitrine-pas]', v).forEach(function (b) {
      b.addEventListener('click', function () {
        var item = $('.vitrine__item', rail); var pas = item ? item.getBoundingClientRect().width + 24 : 320;
        rail.scrollBy({ left: Number(b.dataset.vitrinePas) * pas * (window.innerWidth > 900 ? 2 : 1), behavior: calme ? 'auto' : 'smooth' });
      });
    });
    var depart = null, gauche = 0, bouge = false;
    rail.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') return; depart = e.clientX; gauche = rail.scrollLeft; bouge = false; });
    window.addEventListener('pointermove', function (e) {
      if (depart === null) return;
      var d = e.clientX - depart;
      if (Math.abs(d) > 6) { bouge = true; rail.classList.add('saisi'); }
      if (bouge) rail.scrollLeft = gauche - d;
    });
    window.addEventListener('pointerup', function () { if (depart === null) return; depart = null; setTimeout(function () { rail.classList.remove('saisi'); }, 30); });
    rail.addEventListener('click', function (e) { if (bouge) { e.preventDefault(); e.stopPropagation(); bouge = false; } }, true);
  });

  /* ---------- Loupe générique ---------- */
  function cadreImage(img) {
    var b = img.getBoundingClientRect(), cs = getComputedStyle(img);
    var pl = parseFloat(cs.paddingLeft) || 0, pt = parseFloat(cs.paddingTop) || 0;
    var cw = b.width - pl * 2, ch = b.height - pt * 2;
    var r = (img.naturalWidth || 1) / (img.naturalHeight || 1);
    var fit = cs.objectFit, w, hh;
    if (fit === 'cover') { if (cw / ch > r) { w = cw; hh = cw / r; } else { hh = ch; w = ch * r; } }
    else { if (cw / ch > r) { hh = ch; w = ch * r; } else { w = cw; hh = cw / r; } }
    return { box: b, x: pl + (cw - w) / 2, y: pt + (ch - hh) / 2, w: w, h: hh };
  }
  function placerLoupe(loupe, img, conteneur, px, py, Z) {
    var c = cadreImage(img), cb = conteneur.getBoundingClientRect();
    var L = loupe.offsetWidth;
    var u = (px - c.x) / c.w, v = (py - c.y) / c.h;
    u = Math.min(1, Math.max(0, u)); v = Math.min(1, Math.max(0, v));
    var ox = c.box.left - cb.left, oy = c.box.top - cb.top;
    loupe.style.setProperty('--x', (ox + px - L / 2) + 'px');
    loupe.style.setProperty('--y', (oy + py - L / 2) + 'px');
    loupe.style.backgroundSize = (c.w * Z) + 'px ' + (c.h * Z) + 'px';
    loupe.style.backgroundPosition = (L / 2 - u * c.w * Z) + 'px ' + (L / 2 - v * c.h * Z) + 'px';
  }

  /* ---------- La matière, de près ---------- */
  $$('[data-matiere]').forEach(function (m) {
    var onglets = $$('[data-matiere-onglet]', m), scenes = $$('[data-matiere-scene]', m), details = $$('.matiere__detail', m);
    var actif = 0, raf = null, interaction = false, t0 = performance.now(), reprise = null, visible = false;
    function scene() { return scenes[actif]; }
    function choisir(i) {
      actif = i;
      onglets.forEach(function (o, k) { o.setAttribute('aria-selected', k === i ? 'true' : 'false'); o.tabIndex = k === i ? 0 : -1; });
      scenes.forEach(function (s, k) { s.hidden = k !== i; });
      details.forEach(function (d, k) { d.hidden = k !== i; });
    }
    onglets.forEach(function (o, i) {
      o.addEventListener('click', function () { choisir(i); });
      o.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') { e.preventDefault(); var n = (i + 1) % onglets.length; choisir(n); onglets[n].focus(); }
        if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') { e.preventDefault(); var p = (i - 1 + onglets.length) % onglets.length; choisir(p); onglets[p].focus(); }
      });
    });
    function suivre(e) {
      var s = scene(), img = $('img', s), loupe = $('[data-loupe]', s); if (!img || !loupe) return;
      var b = img.getBoundingClientRect();
      placerLoupe(loupe, img, s, e.clientX - b.left, e.clientY - b.top, 3);
    }
    scenes.forEach(function (s) {
      s.addEventListener('pointerenter', function () { interaction = true; clearTimeout(reprise); });
      s.addEventListener('pointermove', suivre);
      s.addEventListener('pointerdown', suivre);
      s.addEventListener('pointerleave', function () { reprise = setTimeout(function () { interaction = false; }, 1800); });
      var img = $('img', s);
      if (img) img.addEventListener('load', function () { if (!raf) boucle(); });
    });
    function boucle() {
      raf = requestAnimationFrame(boucle);
      if (interaction || !visible) return;
      var s = scene(), img = $('img', s), loupe = $('[data-loupe]', s); if (!img || !loupe || !img.naturalWidth) return;
      var t = (performance.now() - t0) / 1000;
      var c = cadreImage(img);
      var u = .5 + Math.sin(t * .45) * .22, v = .56 + Math.sin(t * .9) * .1;
      placerLoupe(loupe, img, s, c.x + u * c.w, c.y + v * c.h, 3);
    }
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { es.forEach(function (e) { visible = e.isIntersecting; }); }).observe(m);
    else visible = true;
    if (calme) { visible = true; requestAnimationFrame(function () { boucle(); cancelAnimationFrame(raf); }); } else boucle();
  });

  /* ---------- Fiche produit : loupe, plein écran, coloris ---------- */
  var cadre = $('[data-galerie-cadre]');
  if (cadre) {
    var principal = $('.studio__img', cadre), loupeF = $('[data-loupe-fiche]', cadre);
    function fondLoupe() { if (loupeF && principal) loupeF.style.backgroundImage = 'url("' + (principal.dataset.zoom || principal.currentSrc || principal.src) + '")'; }
    fondLoupe();
    document.addEventListener('cocon:image', fondLoupe);
    if (sourisFine && loupeF) {
      cadre.addEventListener('pointermove', function (e) {
        if (e.target.closest('button, .outils-photo')) { loupeF.classList.remove('active'); return; }
        var b = principal.getBoundingClientRect();
        loupeF.classList.add('active');
        placerLoupe(loupeF, principal, cadre, e.clientX - b.left, e.clientY - b.top, 2.5);
      });
      cadre.addEventListener('pointerleave', function () { loupeF.classList.remove('active'); });
    }

    /* Plein écran */
    var pe = $('[data-zoom-plein]'), sceneZ = pe && $('[data-zoom-scene]', pe), imgZ = pe && $('[data-zoom-img]', pe);
    var vignettesZ = $$('.galerie__vignettes button');
    var idxZ = 0, s = 1, tx = 0, ty = 0, dernierFocus = null;
    function appliquer() { imgZ.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + s + ')'; }
    function base() {
      imgZ.style.transform = 'none';
      var r = imgZ.getBoundingClientRect(), sr = sceneZ.getBoundingClientRect();
      tx = r.left - sr.left; ty = r.top - sr.top; s = 1;
      imgZ.style.position = 'absolute'; imgZ.style.left = '0'; imgZ.style.top = '0';
      appliquer();
    }
    function charger(i) {
      if (vignettesZ.length) { idxZ = (i + vignettesZ.length) % vignettesZ.length; imgZ.src = vignettesZ[idxZ].dataset.zoom || vignettesZ[idxZ].dataset.grande; }
      else imgZ.src = principal.dataset.zoom || principal.src;
      imgZ.style.position = ''; imgZ.style.transform = 'none';
      if (imgZ.complete) base(); else imgZ.onload = base;
    }
    function ouvrirZ() {
      if (!pe) return;
      if (pe.parentElement !== document.body) document.body.appendChild(pe);
      dernierFocus = document.activeElement;
      var courant = vignettesZ.findIndex(function (b) { return b.getAttribute('aria-current') === 'true'; });
      pe.hidden = false; document.body.style.overflow = 'hidden';
      charger(courant < 0 ? 0 : courant);
      var f = $('[data-fermer-zoom]', pe); if (f) f.focus();
    }
    function fermerZ() { if (!pe || pe.hidden) return; pe.hidden = true; document.body.style.overflow = ''; if (dernierFocus) dernierFocus.focus(); }
    function zoomer(facteur, cx, cy) {
      var ns = Math.min(6, Math.max(1, s * facteur));
      if (ns === 1) { base(); return; }
      var sr = sceneZ.getBoundingClientRect(); var x = cx - sr.left, y = cy - sr.top;
      tx = x - (x - tx) * (ns / s); ty = y - (y - ty) * (ns / s); s = ns; appliquer();
    }
    if (pe) {
      cadre.addEventListener('click', function (e) { if (e.target.closest('.galerie__nav, .outils-photo') || cadre.dataset.balaye === '1') return; ouvrirZ(); });
      $('[data-ouvrir-zoom]', cadre).addEventListener('click', function (e) { e.stopPropagation(); ouvrirZ(); });
      $('[data-fermer-zoom]', pe).addEventListener('click', fermerZ);
      $$('[data-zoom-pas]', pe).forEach(function (b) { b.addEventListener('click', function () { charger(idxZ + Number(b.dataset.zoomPas)); }); });
      document.addEventListener('keydown', function (e) {
        if (pe.hidden) return;
        if (e.key === 'Escape') fermerZ();
        if (e.key === 'ArrowRight') charger(idxZ + 1);
        if (e.key === 'ArrowLeft') charger(idxZ - 1);
        if (e.key === 'Tab') { var f = $$('button', pe).filter(function (b) { return b.offsetParent; }); if (!f.length) return; var i = f.indexOf(document.activeElement); if (e.shiftKey && i <= 0) { e.preventDefault(); f[f.length - 1].focus(); } else if (!e.shiftKey && i === f.length - 1) { e.preventDefault(); f[0].focus(); } }
      });
      sceneZ.addEventListener('wheel', function (e) { e.preventDefault(); zoomer(e.deltaY < 0 ? 1.18 : 1 / 1.18, e.clientX, e.clientY); }, { passive: false });
      sceneZ.addEventListener('dblclick', function (e) { if (s > 1.05) base(); else zoomer(2.5, e.clientX, e.clientY); });
      var pts = {}, dep = null, dist0 = 0, s0 = 1, tap = 0;
      sceneZ.addEventListener('pointerdown', function (e) {
        sceneZ.setPointerCapture(e.pointerId); pts[e.pointerId] = { x: e.clientX, y: e.clientY };
        var ids = Object.keys(pts);
        if (ids.length === 1) {
          dep = { x: e.clientX, y: e.clientY, tx: tx, ty: ty }; sceneZ.classList.add('saisi');
          var now = Date.now(); if (e.pointerType !== 'mouse' && now - tap < 300) { if (s > 1.05) base(); else zoomer(2.5, e.clientX, e.clientY); } tap = now;
        }
        if (ids.length === 2) { var a = pts[ids[0]], b = pts[ids[1]]; dist0 = Math.hypot(a.x - b.x, a.y - b.y); s0 = s; }
      });
      sceneZ.addEventListener('pointermove', function (e) {
        if (!pts[e.pointerId]) return; pts[e.pointerId] = { x: e.clientX, y: e.clientY };
        var ids = Object.keys(pts);
        if (ids.length === 2) {
          var a = pts[ids[0]], b = pts[ids[1]], d = Math.hypot(a.x - b.x, a.y - b.y);
          zoomer((s0 * d / dist0) / s, (a.x + b.x) / 2, (a.y + b.y) / 2);
        } else if (dep && s > 1) { tx = dep.tx + (e.clientX - dep.x); ty = dep.ty + (e.clientY - dep.y); appliquer(); }
        else if (dep && s === 1 && e.pointerType !== 'mouse') { /* balayage pour changer de photo */ }
      });
      var fin = function (e) {
        var p0 = dep; delete pts[e.pointerId]; sceneZ.classList.remove('saisi');
        if (Object.keys(pts).length === 0) {
          if (p0 && s === 1 && e.pointerType !== 'mouse' && Math.abs(e.clientX - p0.x) > 50) charger(idxZ + (e.clientX < p0.x ? 1 : -1));
          dep = null;
        }
      };
      sceneZ.addEventListener('pointerup', fin); sceneZ.addEventListener('pointercancel', fin);
      window.addEventListener('resize', function () { if (!pe.hidden) base(); });
    }

    /* Aperçu d'un autre coloris au survol */
    var nomColoris = $('[data-coloris-nom]');
    var nomInitial = nomColoris ? nomColoris.textContent : '';
    $$('.coloris--grande [data-coloris-lien]').forEach(function (a) {
      var avant = null;
      a.addEventListener('pointerenter', function () {
        if (!a.dataset.image) return;
        avant = { src: principal.src, srcset: principal.getAttribute('srcset') };
        principal.removeAttribute('srcset'); principal.src = a.dataset.image;
        if (nomColoris) nomColoris.textContent = a.dataset.nom;
      });
      a.addEventListener('pointerleave', function () {
        if (avant) { principal.src = avant.src; if (avant.srcset) principal.setAttribute('srcset', avant.srcset); avant = null; }
        if (nomColoris) nomColoris.textContent = nomInitial;
      });
    });
  }

  /* ---------- FAQ : ouverture animée ---------- */
  $$('.question2').forEach(function (d) {
    var sum = $('summary', d), corps = $('.question2__reponse', d);
    sum.addEventListener('click', function (e) {
      if (calme || !corps.animate) return;
      e.preventDefault();
      if (d.open) {
        var h = corps.offsetHeight;
        var a = corps.animate([{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 320, easing: 'cubic-bezier(.4,0,.2,1)' });
        d.classList.add('ferme'); a.onfinish = function () { d.open = false; d.classList.remove('ferme'); };
      } else {
        d.open = true;
        var h2 = corps.offsetHeight;
        corps.animate([{ height: '0px', opacity: 0 }, { height: h2 + 'px', opacity: 1 }], { duration: 420, easing: 'cubic-bezier(.2,.7,.2,1)' });
      }
    });
  });
})();

/* =====================================================================
   Fiche : couleurs sous la photo, couleur du mur, cotes dessinées
   ===================================================================== */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var cadre = $('[data-galerie-cadre]');
  if (!cadre) return;
  var principal = $('.studio__img', cadre);
  var json = $('[data-produit-json]');
  var donnees = json ? JSON.parse(json.textContent) : null;

  /* Couleurs de variante (linge) juste sous la photo */
  $$('[data-coloris-variante]').forEach(function (bloc) {
    var pos = bloc.dataset.colorisVariante, nom = $('[data-coloris-nom]', bloc);
    var boutons = $$('button[data-valeur]', bloc);
    function maj(val) {
      boutons.forEach(function (b) { var ok = b.dataset.valeur === val; b.classList.toggle('est-choisie', ok); b.setAttribute('aria-pressed', ok ? 'true' : 'false'); });
      if (nom) nom.textContent = val;
    }
    boutons.forEach(function (b) {
      b.addEventListener('click', function () {
        var input = $$('input[name="option-' + pos + '"]').filter(function (i) { return i.value === b.dataset.valeur; })[0];
        if (input) { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
        maj(b.dataset.valeur);
      });
      var avant = null;
      b.addEventListener('pointerenter', function () {
        if (!donnees || b.classList.contains('est-choisie')) return;
        var v = donnees.variants.filter(function (x) { return x.options[pos] === b.dataset.valeur && x.featured_media; })[0];
        if (!v) return;
        avant = { src: principal.src, srcset: principal.getAttribute('srcset') };
        principal.removeAttribute('srcset'); principal.src = v.featured_media.preview_image.src + (v.featured_media.preview_image.src.indexOf('?') > -1 ? '&' : '?') + 'width=1200';
        if (nom) nom.textContent = b.dataset.valeur;
      });
      b.addEventListener('pointerleave', function () {
        if (!avant) return;
        principal.src = avant.src; if (avant.srcset) principal.setAttribute('srcset', avant.srcset); avant = null;
        var c = boutons.filter(function (x) { return x.classList.contains('est-choisie'); })[0]; if (nom && c) nom.textContent = c.dataset.valeur;
      });
    });
    $$('input[name="option-' + pos + '"]').forEach(function (i) { i.addEventListener('change', function () { if (i.checked) maj(i.value); }); });
  });

  /* Couleur du mur */
  var teinteOrigine = cadre.style.getPropertyValue('--teinte');
  var scene = $('[data-zoom-scene]');
  $$('[data-mur]').forEach(function (b, _, tous) {
    b.addEventListener('click', function () {
      var actif = b.getAttribute('aria-pressed') === 'true';
      tous.forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
      var t = actif ? teinteOrigine : b.dataset.mur;
      if (!actif) b.setAttribute('aria-pressed', 'true');
      cadre.style.setProperty('--teinte', t);
      if (scene) scene.style.setProperty('--teinte', t);
    });
  });

  /* Cotes dessinées sur la photo */
  var bouton = $('[data-cotes-bouton]'), svg = $('[data-cotes]'), source = $('[data-dimensions-texte]');
  if (!bouton || !svg || !source) return;
  var txt = source.dataset.dimensionsTexte;
  var nombres = (txt.match(/\d+(?:[,.]\d+)?/g) || []).slice(0, 3);
  if (nombres.length < 2) return;
  var ordre = (txt.match(/\(([LPHlph])\s*x\s*([LPHlph])\s*(?:x\s*([LPHlph]))?\)/) || []).slice(1).filter(Boolean).map(function (x) { return x.toUpperCase(); });
  if (ordre.length !== nombres.length) ordre = ['L', 'P', 'H'].slice(0, nombres.length);
  var dim = {}; ordre.forEach(function (k, i) { dim[k] = nombres[i].replace('.', ','); });
  bouton.hidden = false;
  var boite = null;
  function cadreImg() {
    var b = principal.getBoundingClientRect(), cs = getComputedStyle(principal);
    var pl = parseFloat(cs.paddingLeft) || 0, pt = parseFloat(cs.paddingTop) || 0;
    var cw = b.width - pl * 2, ch = b.height - pt * 2, r = (principal.naturalWidth || 1) / (principal.naturalHeight || 1), w, h;
    if (cw / ch > r) { h = ch; w = ch * r; } else { w = cw; h = cw / r; }
    var cb = cadre.getBoundingClientRect();
    return { x: b.left - cb.left + pl + (cw - w) / 2, y: b.top - cb.top + pt + (ch - h) / 2, w: w, h: h };
  }
  function mesurer(fin) {
    var im = new Image(); im.crossOrigin = 'anonymous';
    var src = (principal.currentSrc || principal.src).replace(/([?&])width=\d+/, '$1width=240');
    if (src.indexOf('width=') < 0) src += (src.indexOf('?') > -1 ? '&' : '?') + 'width=240';
    im.onload = function () {
      try {
        var c = document.createElement('canvas'); c.width = im.width; c.height = im.height;
        var x = c.getContext('2d'); x.drawImage(im, 0, 0);
        var d = x.getImageData(0, 0, c.width, c.height).data, x0 = c.width, y0 = c.height, x1 = 0, y1 = 0;
        for (var yy = 0; yy < c.height; yy++) for (var xx = 0; xx < c.width; xx++) {
          var k = (yy * c.width + xx) * 4; if (Math.min(d[k], d[k + 1], d[k + 2]) < 225) { if (xx < x0) x0 = xx; if (xx > x1) x1 = xx; if (yy < y0) y0 = yy; if (yy > y1) y1 = yy; }
        }
        if (x1 > x0 && y1 > y0) boite = { l: x0 / c.width, t: y0 / c.height, r: (x1 + 1) / c.width, b: (y1 + 1) / c.height };
      } catch (e) {}
      fin();
    };
    im.onerror = fin; im.src = src;
  }
  function dessiner() {
    var c = cadreImg(), bx = boite || { l: .1, t: .2, r: .9, b: .8 };
    var L = c.x + bx.l * c.w, R = c.x + bx.r * c.w, T = c.y + bx.t * c.h, B = c.y + bx.b * c.h;
    var W = cadre.clientWidth, H = cadre.clientHeight;
    var yb = Math.min(B + 22, H - 30), xr = Math.min(R + 22, W - 20);
    svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
    function etiquette(x, y, t) { var w = t.length * 7.6 + 18; return '<rect x="' + (x - w / 2) + '" y="' + (y - 13) + '" width="' + w + '" height="26" rx="13"/><text x="' + x + '" y="' + (y + 4.5) + '" text-anchor="middle">' + t + '</text>'; }
    var h = '';
    if (dim.L) h += '<line class="trait-tirets" x1="' + L + '" y1="' + B + '" x2="' + L + '" y2="' + (yb + 6) + '"/><line class="trait-tirets" x1="' + R + '" y1="' + B + '" x2="' + R + '" y2="' + (yb + 6) + '"/>' +
      '<path d="M' + L + ' ' + yb + 'H' + R + 'M' + (L + 7) + ' ' + (yb - 5) + 'L' + L + ' ' + yb + 'L' + (L + 7) + ' ' + (yb + 5) + 'M' + (R - 7) + ' ' + (yb - 5) + 'L' + R + ' ' + yb + 'L' + (R - 7) + ' ' + (yb + 5) + '"/>' + etiquette((L + R) / 2, yb, 'Largeur ' + dim.L + ' cm');
    if (dim.H) h += '<line class="trait-tirets" x1="' + R + '" y1="' + T + '" x2="' + (xr + 6) + '" y2="' + T + '"/>' +
      '<path d="M' + xr + ' ' + T + 'V' + B + 'M' + (xr - 5) + ' ' + (T + 7) + 'L' + xr + ' ' + T + 'L' + (xr + 5) + ' ' + (T + 7) + 'M' + (xr - 5) + ' ' + (B - 7) + 'L' + xr + ' ' + B + 'L' + (xr + 5) + ' ' + (B - 7) + '"/>' + etiquette(Math.max(R - 44, L + 40), (T + B) / 2, 'H ' + dim.H + ' cm');
    if (dim.P) h += etiquette(Math.max(L + 70, 90), Math.max(T - 22, 70), 'Profondeur ' + dim.P + ' cm');
    svg.innerHTML = h;
  }
  function afficher(oui) {
    bouton.setAttribute('aria-pressed', oui ? 'true' : 'false');
    if (!oui) { svg.classList.remove('visible'); return; }
    mesurer(function () { dessiner(); svg.classList.remove('visible'); void svg.getBoundingClientRect(); svg.classList.add('visible'); });
  }
  bouton.addEventListener('click', function (e) { e.stopPropagation(); afficher(bouton.getAttribute('aria-pressed') !== 'true'); });
  $$('[data-cotes-voir]').forEach(function (v) { v.addEventListener('click', function () { cadre.scrollIntoView({ behavior: 'smooth', block: 'center' }); setTimeout(function () { afficher(true); }, 450); }); });
  document.addEventListener('cocon:image', function () { afficher(false); });
  window.addEventListener('resize', function () { if (bouton.getAttribute('aria-pressed') === 'true') dessiner(); });
})();

/* Ruban tricolore : figé si l'utilisateur limite les animations */
(function () {
  if (!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) return;
  Array.prototype.forEach.call(document.querySelectorAll('svg.ruban'), function (s) { try { s.setCurrentTime(2); s.pauseAnimations(); } catch (e) {} });
})();


/* Recadrage : le meuble remplit le cadre ; une photo d'ambiance occupe tout le cadre */
(function () {
  var sel = '.carte__media.studio--detoure .studio__img, .matiere__scene.studio--detoure .studio__img, .porte2__visuel.studio--detoure .studio__img, .recit__media.studio--detoure .studio__img';
  var imgs = Array.prototype.slice.call(document.querySelectorAll(sel));
  if (!imgs.length) return;
  function petite(url) {
    try { var u = new URL(url, location.href); u.searchParams.set('width', '160'); u.searchParams.delete('height'); u.searchParams.delete('crop'); return u.href; } catch (e) { return null; }
  }
  function appliquer(img) {
    var d = img._cadre; if (!d) return;
    var Fw = img.clientWidth, Fh = img.clientHeight; if (!Fw || !Fh) return;
    var r = d.r, dw, dh;
    if (Fw / Fh > r) { dh = Fh; dw = Fh * r; } else { dw = Fw; dh = Fw / r; }
    var ox = (Fw - dw) / 2, oy = (Fh - dh) / 2;
    var bx = ox + d.x0 * dw, by = oy + d.y0 * dh, bw = (d.x1 - d.x0) * dw, bh = (d.y1 - d.y0) * dh;
    var s = Math.min(.88 * Fw / bw, .8 * Fh / bh, 3);
    if (s < 1.02) s = 1;
    var cx = bx + bw / 2, cy = by + bh / 2;
    img.style.transformOrigin = cx + 'px ' + cy + 'px';
    img.style.transform = 'translate(' + (Fw / 2 - cx) + 'px,' + (Fh * .52 - cy) + 'px) scale(' + s.toFixed(3) + ')';
  }
  function analyser(img) {
    var src = petite(img.currentSrc || img.src); if (!src) return;
    var t = new Image(); t.crossOrigin = 'anonymous';
    t.onload = function () {
      try {
        var w = t.naturalWidth, h = t.naturalHeight, c = document.createElement('canvas');
        c.width = w; c.height = h; var x = c.getContext('2d', { willReadFrequently: true }); x.drawImage(t, 0, 0);
        var p = x.getImageData(0, 0, w, h).data, i, X, Y;
        var bord = 0, blanc = 0;
        function pix(X, Y) { var k = (Y * w + X) * 4; return Math.min(p[k], p[k + 1], p[k + 2]); }
        for (X = 0; X < w; X += 2) { bord += 2; if (pix(X, 0) > 232) blanc++; if (pix(X, h - 1) > 232) blanc++; }
        for (Y = 0; Y < h; Y += 2) { bord += 2; if (pix(0, Y) > 232) blanc++; if (pix(w - 1, Y) > 232) blanc++; }
        if (blanc / bord < .7) { img.classList.add('est-photo'); return; }
        var x0 = w, y0 = h, x1 = -1, y1 = -1;
        for (Y = 0; Y < h; Y++) for (X = 0; X < w; X++) { if (pix(X, Y) < 222) { if (X < x0) x0 = X; if (X > x1) x1 = X; if (Y < y0) y0 = Y; if (Y > y1) y1 = Y; } }
        if (x1 < 0 || (x1 - x0) < w * .1) return;
        img._cadre = { r: w / h, x0: Math.max(0, x0 - 1) / w, y0: Math.max(0, y0 - 1) / h, x1: Math.min(w, x1 + 2) / w, y1: Math.min(h, y1 + 2) / h };
        img.classList.add('est-recadre');
        appliquer(img);
      } catch (e) {}
    };
    t.src = src;
  }
  function pret(img) { if (img.complete && img.naturalWidth) analyser(img); else img.addEventListener('load', function () { analyser(img); }, { once: true }); }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); pret(e.target); } }); }, { rootMargin: '600px' });
    imgs.forEach(function (i) { io.observe(i); });
  } else imgs.forEach(pret);
  var minuteur;
  window.addEventListener('resize', function () { clearTimeout(minuteur); minuteur = setTimeout(function () { imgs.forEach(appliquer); }, 150); });
})();

/* Protection anti-copie : clic droit, glisser, copier, appui long sur les images */
(function () {
  function champ(t) { return t && t.closest && t.closest('input, textarea, select, [contenteditable="true"]'); }
  document.addEventListener('contextmenu', function (e) { if (!champ(e.target)) e.preventDefault(); });
  document.addEventListener('dragstart', function (e) { if (e.target && (e.target.tagName === 'IMG' || e.target.closest && e.target.closest('a img'))) e.preventDefault(); });
  ['copy', 'cut'].forEach(function (ev) { document.addEventListener(ev, function (e) { if (!champ(e.target)) e.preventDefault(); }); });
  document.addEventListener('selectstart', function (e) { if (!champ(e.target)) e.preventDefault(); });
  document.addEventListener('keydown', function (e) {
    var k = (e.key || '').toLowerCase();
    if ((e.ctrlKey || e.metaKey) && (k === 's' || k === 'u' || ((k === 'c' || k === 'a') && !champ(e.target)))) e.preventDefault();
  });
})();

/* Dans le détail : révélation douce des photos */
(function () {
  var l = document.querySelectorAll('.recit__ligne'); if (!l.length) return;
  if (!('IntersectionObserver' in window)) { l.forEach(function (e) { e.classList.add('est-visible'); }); return; }
  var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('est-visible'); io.unobserve(e.target); } }); }, { rootMargin: '0px 0px -12% 0px' });
  l.forEach(function (e) { io.observe(e); });
})();

/* Panier : ajouter un article de linge proposé */
(function () {
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-linge-ajouter]'); if (!b) return;
    e.preventDefault();
    var bloc = b.closest('[data-ajout-linge]'), champ = bloc && bloc.querySelector('[data-linge-id]');
    if (!champ) return;
    b.disabled = true; var t = b.textContent; b.textContent = 'Ajout…';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(champ.value), quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw new Error('ajout'); })
      .then(function () {
        if (document.body.classList.contains('gabarit-cart')) { location.reload(); return; }
        return fetch('/?sections=panier-tiroir,compteur-panier').then(function (r) { return r.json(); }).then(function (sct) {
          var neuf = new DOMParser().parseFromString(sct['panier-tiroir'], 'text/html').querySelector('#tiroir-panier');
          var tir = document.getElementById('tiroir-panier'); if (neuf && tir) tir.innerHTML = neuf.innerHTML;
          var cpt = new DOMParser().parseFromString(sct['compteur-panier'], 'text/html').querySelector('[data-compteur]');
          document.querySelectorAll('[data-compteur]').forEach(function (el) { if (cpt) el.outerHTML = cpt.outerHTML; });
        });
      })
      .catch(function () { b.textContent = 'Indisponible'; setTimeout(function () { b.textContent = t; b.disabled = false; }, 2000); });
  });
})();

/* ---------- Orientation de l'angle (canapés réversibles) ---------- */
document.addEventListener('change', function (e) {
  var r = e.target.closest('[data-orientation-choix]');
  if (!r) return;
  var fs = r.closest('[data-orientation]');
  fs.classList.remove('est-a-choisir');
  var nom = fs.querySelector('[data-orientation-nom]'); if (nom) nom.textContent = r.value;
  var f = r.closest('form'); var m = f && f.querySelector('[data-message-panier]'); if (m) m.hidden = true;
});
